import { useFeatureFlagObserver } from '@hooks/useFeatureFlagObserver';
import { FeatureFlagKeys } from '@lib/experiment';
import useStores from '@stores/useStores';

/**
 * Whether the inline Get started flag is on in this workspace, whoever the user is. With it on the
 * old checklist drawer is gone for everyone. Flagsmith buckets by workspace (see
 * `experiment.identify`).
 */
export const useIsInlineGetStartedFlagOn = () =>
  useFeatureFlagObserver(FeatureFlagKeys.enableInlineGetStarted);

/**
 * Whether this user gets the inline Get started page, in place of the quick start page: an
 * organization admin, in a workspace with the flag on. Everyone else keeps the quick start page,
 * which only some plans have. Callers read the user through MobX, so they must be observers.
 */
export const useIsInlineGetStartedEnabled = () => {
  const { userStore } = useStores();
  const isFlagOn = useIsInlineGetStartedFlagOn();

  return isFlagOn && userStore.isOrgAdmin;
};
